export const scrollEffect = ( startHeight, endHeight, startValue, EndValue ) => {
    const a = ( startValue - EndValue ) / ( startHeight - endHeight );
    const b = ( endHeight * startValue - startHeight * EndValue ) / ( endHeight - startHeight );
    return { a, b };
}